import Vue from 'vue'
import App from './App.vue'

import moment from 'moment-timezone';
// 設置全局默認時區為用戶的時區
const userTimeZone = moment.tz.guess();
moment.tz.setDefault(userTimeZone);

import './registerServiceWorker'
import store from './store'
import router from './router'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

import '/src/assets/scss/main.scss'

Vue.config.productionTip = false
Vue.use(require('vue-cookies'));

const requireAll = requireContext => requireContext.keys().map(requireContext);
const req = require.context("./assets/icons/svg", true, /\.svg$/);
requireAll(req);
import Icon from "@/components/Icon";
Vue.component("Icon", Icon);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
